export const GREETING_OPTIONS = ['Hi', 'Hello', 'Howdy', 'Kia Ora', 'G-day', 'Hey', 'Dear', 'Greetings', 'To'];

export const SIGNOFF_OPTIONS = ['Thanks', 'Regards', 'Cheers', 'Happy Volunteering', 'Thank you', 'All the best'];
